import React, { FC } from 'react';
import AgentMap from '~/pages/agent/components/agentMap';

const Map: FC = () => {
  return <AgentMap />;
};

export default Map;
